//@ts-check
import React from 'react';
import Formatter from '../../../formatter';
var INTERACTION_FILTERS = ['accountId', 'contactId', 'journeyId', 'touchpointId', 'threadId', 'projectTag'];
/**@type {import('../types').DataType<import('./types').InteractionDataModel>} */

var INTERACTION_DATA_TYPE = {
  data: {
    url: '/backend/interactionsjob',
    dataKey: 'interactions',
    idKeyProp: 'Id',
    onBeforeRequest: function onBeforeRequest(options, request) {
      if (request.type === 'loadView' && options.dataProps) {
        var filter = {};
        Object.keys(options.dataProps).map(function (f) {
          if (INTERACTION_FILTERS.indexOf(f) > -1) filter[f] = options.dataProps[f];
        });
        return {
          query: filter
        };
      }
    }
  },
  placeholders: {
    label: function label(data) {
      return data ? data.Communication.Name : '';
    },
    type: function type() {
      return 'interaction';
    },
    icon: function icon() {
      return 'interaction';
    }
  },
  columns: [{
    id: 'Name',
    children: 'Name',
    formatter: function formatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.Text, {
        value: data.Communication.Name
      });
    }
  }, {
    id: 'Timestamp',
    children: 'Date',
    formatter: function formatter(_ref2) {
      var data = _ref2.data;
      return React.createElement(Formatter.DateTime, {
        value: data.Timestamp
      });
    }
  }, {
    id: 'Touchpoint',
    children: 'Touchpoint',
    formatter: function formatter(_ref3) {
      var data = _ref3.data;
      return React.createElement(Formatter.JourneyTouchpoint, {
        value: data.Touchpoint.Name,
        color: data.Touchpoint.Color,
        type: data.Touchpoint.IsMilestone ? 'milestone' : 'touchpoint'
      });
    }
  }, {
    id: 'Contact',
    children: React.createElement(Formatter.Placeholders, {
      template: "{type}",
      dataType: "contact",
      capitalize: true
    }),
    formatter: function formatter(_ref4) {
      var data = _ref4.data;
      return React.createElement(Formatter.Text, {
        value: data.Contact.Name
      });
    }
  }],
  thumbnail: {
    url: function url() {
      return '';
    },
    text: function text(data) {
      return data.Communication.Name;
    },
    icon: function icon() {
      return 'interaction';
    } // contextMenu: [],

  }
};
export default INTERACTION_DATA_TYPE;